import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { getMyAvailabilityConstants } from 'src/redux/actions/constant';
import ptoRequestServices from 'src/services/apiServices/my-availability-services/pto-request-service';

const {
  GET_MY_AVAILABILITY_LOADING,
  CREATE_PTO_REQUEST_REQUEST,
  CREATE_PTO_SUCCESS_REQUEST,
  CREATE_PTO_FAILURE_REQUEST,
} = getMyAvailabilityConstants;

function* createRequestPto(action: any): SagaReturnType<any> {
  try {
    const response = yield call(
      ptoRequestServices.createPtoRequest,
      action.payload,
      action.providerId
    );
    if (response?.status === 201) {
      yield put({ type: CREATE_PTO_SUCCESS_REQUEST, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: CREATE_PTO_FAILURE_REQUEST, payload: error });
  }
}

function* createPtoRequestSaga() {
  yield takeEvery(CREATE_PTO_REQUEST_REQUEST, createRequestPto);
}

export default createPtoRequestSaga;
